import React from 'react';
import { isStandAloneApp } from '../../utils/services/CommonUtils';
import DashboardComponent from '../tab-component/DashboardComponent';

import AppTheme from "../../AppTheme";

const DashboardScreen = (props) => {

    function getHomeBottomPadding() {
        let padding = AppTheme.bottomNavBarHeight
        if (isStandAloneApp()) padding -= 60
        return padding
    }
    
    return (
        <DashboardComponent getBottomPadding={() => getHomeBottomPadding()}
            navigation={props.navigation} route={props.route} />
    )
}

export default DashboardScreen
